import axiosClient from './axiosClient';
import { API_URLS } from '../constants/apiUrls';
import { IDriverAllocation } from '../interfaces/driverAllocationReq';

const driverAllocationAPI = {
  getDriverPickupAllocation: (ownerId: number, date: string) => {
    return axiosClient.get(
      `${API_URLS.DRIVER_PICKUP_ALLOCATION}?ownerId=${ownerId}&date=${date}`,
    );
  },
  addDriverPickupAllocation: (payload: IDriverAllocation[]) => {
    return axiosClient.post(`${API_URLS.DRIVER_PICKUP_ALLOCATION}`, payload);
  },

  getDriverDropOffAllocation: (ownerId: number, date: string) => {
    return axiosClient.get(
      `${API_URLS.DRIVER_DROPOFF_ALLOCATION}?ownerId=${ownerId}&date=${date}`,
    );
  },
  addDriverDropOffAllocation: (payload: IDriverAllocation[]) => {
    return axiosClient.post(`${API_URLS.DRIVER_DROPOFF_ALLOCATION}`, payload);
  },
};

export default driverAllocationAPI;
